import { render, staticRenderFns } from "./WebPagesUpsellBlockForm.vue?vue&type=template&id=65ae3184&"
import script from "./WebPagesUpsellBlockForm.vue?vue&type=script&lang=js&"
export * from "./WebPagesUpsellBlockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports